import { TABLE_THEME } from '@/components/custom/erp/table-theme';

export const inputTableClassName = [
  'border',
  TABLE_THEME.surfaceBorder,
  TABLE_THEME.inputHeaderCell,
  '[&_thead_th]:text-[12.5px]',
  TABLE_THEME.inputBodyCell,
  '[&_tbody_td]:text-[12.5px]'
].join(' ');
